const ANALYTICS_OWNER_IDENTITY = 'postmaster@analytics.msging.net';
import { DASHBOT_ACTIVE } from '../IntegrationsController';
import './dashbotView.scss';
import { IntegrationsFeatures } from '../IntegrationsFeatures';
export class DashbotController {
    static $inject = ['LoadingService', 'ConfigurationsService', 'application', 'ngToast', '$translate', 'SegmentService', 'IntegrationsSegmentService', 'IntegrationsService'];
    constructor(LoadingService, ConfigurationsService, application, ngToast, $translate, SegmentService, IntegrationsSegmentService, IntegrationsService) {
        'ngInject';
        this.LoadingService = LoadingService;
        this.ConfigurationsService = ConfigurationsService;
        this.application = application;
        this.ngToast = ngToast;
        this.$translate = $translate;
        this.SegmentService = SegmentService;
        this.IntegrationsSegmentService = IntegrationsSegmentService;
        this.IntegrationsService = IntegrationsService;
        this.onChangeUrl = (event) => {
            const { detail: { value } } = event;
            this.settings['Dashbot.Token'] = value;
        };
        this.init();
    }
    async init() {
        this.settings = {};
        await this.checkFeatures();
        this.IntegrationsSegmentService.setApplication(this.application);
        await this.fetchConfiguration();
    }
    async checkFeatures() {
        this.isConfigurationsApplicationsDomainUsageGetEnabled = await IntegrationsFeatures.isConfigurationsDomainOnChannelsOperationsGetEnabled();
        this.isConfigurationsApplicationsDomainUsageSetEnabled = await IntegrationsFeatures.isConfigurationsDomainOnChannelsOperationsSetEnabled();
    }
    async fetchConfiguration() {
        try {
            this.LoadingService.startLoading();
            this.settings = await this.ConfigurationsService.get(ANALYTICS_OWNER_IDENTITY, undefined, this.isConfigurationsApplicationsDomainUsageGetEnabled);
            this.isActive =
                this.settings[DASHBOT_ACTIVE].toLowerCase() == 'true'
                    ? true
                    : false;
        }
        finally {
            this.oldSettings = { ...this.settings };
            this.LoadingService.stopLoading();
        }
    }
    async onToggle(value) {
        this.isActive = value;
        this.LoadingService.startLoading();
        try {
            this.settings[DASHBOT_ACTIVE] = this.isActive;
            await this.ConfigurationsService.set(ANALYTICS_OWNER_IDENTITY, this.settings, undefined, this.isConfigurationsApplicationsDomainUsageSetEnabled);
            if (this.isActive) {
                this.SegmentService.createTrack('integrate-chatbot', {
                    botName: this.application.name,
                    template: this.application.template,
                    integration: 'Dashbot',
                });
            }
        }
        catch (e) {
            const errorMsg8 = await this.$translate('utils.errorMsg.10');
            this.ngToast.danger(errorMsg8);
            this.isActive = !this.isActive;
        }
        finally {
            this.LoadingService.stopLoading();
        }
    }
    async save() {
        this.settings['Dashbot.Url'] = `https://tracker.dashbot.io/track?type=all&platform=blip&v=9.9.2-rest&apiKey=${this.settings['Dashbot.Token']}`;
        try {
            this.LoadingService.startLoading();
            await this.ConfigurationsService.set(ANALYTICS_OWNER_IDENTITY, this.settings, undefined, this.isConfigurationsApplicationsDomainUsageSetEnabled);
            this.afterSave();
            const successMsg8 = await this.$translate('utils.successMsg.8');
            this.ngToast.success(successMsg8);
        }
        catch (err) {
            const errorMsg8 = await this.$translate('utils.errorMsg.10');
            this.ngToast.danger(errorMsg8);
        }
        finally {
            this.LoadingService.stopLoading();
        }
    }
    afterSave() {
        if (this.isTokenNew()) {
            this.trackConnectionDashbotConfigurationAddSaved();
        }
        else {
            this.trackConnectionDashbotConfigurationChangesSaved(this.IntegrationsService.objectsDifferentKeys(this.settings, this.oldSettings));
        }
        this.oldSettings = { ...this.settings };
    }
    isTokenNew() {
        return this.settings['Dashbot.Token'] &&
            this.oldSettings['Dashbot.Token'] === undefined;
    }
    // Segment
    trackConnectionDashbotConfigurationAddSaved() {
        this.IntegrationsSegmentService
            .trackConnectionDashbotConfigurationAddSaved({
            Token: this.settings['Dashbot.Token'],
        });
    }
    trackConnectionDashbotConfigurationChangesSaved(changedFields) {
        this.IntegrationsSegmentService
            .trackConnectionDashbotConfigurationChangesSaved({
            ChangedFields: changedFields,
        });
    }
}
DashbotController.$inject = ['LoadingService', 'ConfigurationsService', 'application', 'ngToast', '$translate', 'SegmentService', 'IntegrationsSegmentService', 'IntegrationsService'];
